/**
 * Created by contrapro on 03/04/2018
 */

import {  ACTION_TYPE_LOGIN_RESULT, ACTION_TYPE_LOGIN_ERROR
    , ACTION_TYPE_REDIRECT_TO
} from '../actions';

const initialState = {
    isAuthenticated: false,
    redirectUrl: '',
    sessionToken: '',
};

export default function loginReducer(state = initialState, action) {
    switch (action.type) {
        // case ACTION_TYPE_LOGIN:
        //     return Object.assign({}, ...state, {
        //         isAuthenticated: true
        //     });
        case ACTION_TYPE_LOGIN_RESULT:
            console.log('login reducer ACTION_TYPE_LOGIN_RESULT', action.payload);
            return {
                ...state,
                isAuthenticated: true,
                sessionToken: action.payload.session
            };
        case ACTION_TYPE_LOGIN_ERROR:
            return Object.assign({}, ...state, {
                isAuthenticated: false
            });

        case ACTION_TYPE_REDIRECT_TO:
            return Object.assign({}, ...state, {
                redirectUrl: action.payload.url
            });
        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/login.js